import * as yup from 'yup';

import { email_or_phone_number } from 'utils/Validation';

export const certificateSchema = yup.object().shape(
  {
    titleArtwork: yup.string().required('This field is required').max(50),

    height: yup
      .string()
      .required('This field is required')
      .test('max-two-decimals', 'No more than 2 decimal places allowed', (number) => {
        if (!number) return false;
        return /^\d+(\.\d{1,2})?$/.test(String(number));
      })
      .test('positive-number', 'Must be greater than 0', (number) => {
        if (!number) return false;
        const n = parseFloat(String(number));
        return !Number.isNaN(n) && n > 0;
      }),

    width: yup
      .string()
      .required('This field is required')
      .test('max-two-decimals', 'No more than 2 decimal places allowed', (number) => {
        if (!number) return false;
        return /^\d+(\.\d{1,2})?$/.test(String(number));
      })
      .test('positive-number', 'Must be greater than 0', (number) => {
        if (!number) return false;
        const n = parseFloat(String(number));
        return !Number.isNaN(n) && n > 0;
      }),

    depth: yup
      .string()
      .notRequired()
      .test('max-two-decimals', 'No more than 2 decimal places allowed', (number) => {
        if (!number) return true;
        return /^\d+(\.\d{1,2})?$/.test(String(number));
      })
      .test('positive-number', 'Must be greater than 0', (number) => {
        if (!number) return true;
        const n = parseFloat(String(number));
        return !Number.isNaN(n) && n > 0;
      }),

    yearCreated: yup.number('invalid number').when('periodYear', {
      is: (periodYear) => !!periodYear,
      then: (schema) =>
        schema.transform((value) => (Number.isNaN(value) ? null : value)).notRequired(),
      otherwise: (schema) =>
        schema
          .transform((value) => (Number.isNaN(value) ? null : value))
          .typeError('Amount must be a number')
          .required('This field is required')
          .positive('Year must be a positive number')
          .integer('Year must be an integer')
          .test('valid-year', 'Invalid year', (value) => {
            const currentYear = new Date().getFullYear();
            return value >= 1 && value <= currentYear;
          }),
    }),

    periodYear: yup.string().when('yearCreated', {
      is: (yearCreated) => !!yearCreated,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required('Period Year is required').max(200, 'Max 200 characters'),
    }),

    edition: yup
      .object()
      .test('has-data', 'Edition is required and must have data', (value) => {
        return value && Object.keys(value).length > 0;
      })
      .required('This field is required'),

    mediumArtWork: yup.object().required('This field is required'),

    piece: yup
      .number()
      .typeError('Must be a number')
      .required('This field is required')
      .integer('Must be an integer')
      .positive('Must be a positive number'),

    owner: yup
      .object()
      .required('Owner is required')
      .when('newOwner', {
        is: (newOwner) => newOwner && Object.keys(newOwner).length > 0,
        then: (schema) => schema.notRequired(),
      }),

    newOwner: yup
      .object()
      .notRequired()
      .when('owner', {
        is: (owner) => !owner || Object.keys(owner).length === 0,
        then: (schema) =>
          schema.required().shape({
            name: yup.string().required('Owner name is required'),
            contactInfo: yup
              .string()
              .required('Email or phone number is required')
              .matches(email_or_phone_number, 'Must be a valid email or phone number'),
            role: yup
              .number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .typeError('Role must be a number')
              .required('Role is required'),
            yearOfBirth: yup
              .number()
              .typeError('Year of birth must be a number')
              .required('Year of birth is required'),
            address: yup.string().required('Address is required'),
          }),
      }),

    contractNumber: yup.string().matches(/^[a-zA-Z0-9-]{1,15}$/, {
      excludeEmptyString: true,
      message: 'Contract Number must be alphanumeric and can include hyphens, up to 15 characters',
    }),
  },
  [
    ['periodYear', 'yearCreated'],
    ['owner', 'newOwner'],
  ],
);
